import {InitialInstructions} from 'presentation/pages/others/facial-biometrics/pages';
import React from 'react';

export const MakeInitialInstructions: React.FC = () => <InitialInstructions />;
